import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { FirebaseNotificationManager } from 'helpers/pushes/FirebaseNotificationManager';
import { isPushPermissionsAsked } from 'helpers/pushes/webpush';
import { isMonetizationPage } from 'helpers/route';
import { usePartnerId } from 'hooks/usePartnerId';

type Params = {
  isAuthenticated: boolean | null;
};

const REQUEST_PERMISSIONS_TIMEOUT = 30 * 1000; // 30 sec

export const useRequestPushPermissions = ({ isAuthenticated }: Params) => {
  const history = useHistory();
  const timerId = useRef<NodeJS.Timeout | null>(null);

  const { isOrganicPartnerIdOnMainMirror } = usePartnerId();

  useEffect(() => {
    const clearTimer = () => {
      if (timerId.current) {
        clearTimeout(timerId.current);

        timerId.current = null;
      }
    };

    if (!isAuthenticated || isOrganicPartnerIdOnMainMirror) {
      return () => {
        clearTimer();
      };
    }

    const unlisten = history.listen((location: any) => {
      if (
        !isAuthenticated ||
        isPushPermissionsAsked() ||
        isMonetizationPage(location.pathname)
      ) {
        clearTimer();

        return;
      }

      if (timerId.current) {
        return;
      }

      timerId.current = setTimeout(() => {
        FirebaseNotificationManager.requestPushPermissionsAndTrack();
      }, REQUEST_PERMISSIONS_TIMEOUT);
    });

    if (
      isPushPermissionsAsked() ||
      isMonetizationPage(document.location.href)
    ) {
      return () => {
        clearTimer();
      };
    }

    timerId.current = setTimeout(() => {
      FirebaseNotificationManager.requestPushPermissionsAndTrack();
    }, REQUEST_PERMISSIONS_TIMEOUT);

    return () => {
      clearTimer();
      unlisten();
    };
  }, [isAuthenticated, history, isOrganicPartnerIdOnMainMirror]);
};
